import * as React from 'react';
import merge from 'lodash.merge';
import Highcharts from 'highcharts';
import {Text} from 'components/UIKit';
import {ListingMetric} from '../ListingMetrics';
import {ListingChartType} from '../../types';
import {REV_CHART_OPTIONS, HIGHCHARTS_OPTIONS, TRAFFIC_CHART_OPTIONS} from './ListingChartOptions';
import styles from './ListingChart.scss';

export interface ListingChartProps {
  id: string;
  type: ListingChartType;
  unit: string;
  total: number;
  heading: string;
  data: Highcharts.Series;
}

export class ListingChart extends React.Component<ListingChartProps> {
  chart!: Highcharts.Chart;
  chartNode!: HTMLElement;

  buildChart(): Highcharts.Chart {
    const {type, id, data: chartData} = this.props;
    const highchartOptions = type === 'revenue' ? REV_CHART_OPTIONS : TRAFFIC_CHART_OPTIONS;

    const data = Object.keys(chartData).map((date) => [new Date(date).getTime(), chartData[date]]);

    const chartOptions = merge(
      {
        chart: {
          renderTo: this.chartNode,
          height: 400,
        },
        series: [
          {
            id,
            type: 'area',
            data,
          },
        ],
      },
      highchartOptions,
      HIGHCHARTS_OPTIONS,
    );

    return new Highcharts.Chart(chartOptions);
  }

  setupChart = (node: HTMLElement | null): void => {
    if (!node) {
      return;
    }

    this.chartNode = node;
  };

  componentDidMount() {
    this.chart = this.buildChart();
    setTimeout(() => this.chart.reflow(), 1);
  }

  render() {
    const {type, unit, total, heading} = this.props;
    const showCurrency = type === 'revenue';

    return (
      <section className={styles.Container}>
        <div className={styles.Header}>
          <Text text={heading} resetMargin />
          <ListingMetric metric={{value: String(total), currency: showCurrency}} suffix={unit} />
        </div>
        <div className={styles.Chart} ref={this.setupChart} />
      </section>
    );
  }
}

export default ListingChart;
